import { MoneyString } from 'model/Money'
import { RootAppState } from 'store/configureStore'

export const projectPricePerBatchSelector = (state: RootAppState) =>
  MoneyString(state.project.activeProject?.financial.salesPricePerItem)
